var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopySquareWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#2858FD",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#2858FD",
    strokeOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4813 11.7573C11.3576 11.7573 11.2573 11.8576 11.2573 11.9813V16.6493C11.2573 16.773 11.3576 16.8733 11.4813 16.8733H16.1493C16.273 16.8733 16.3733 16.773 16.3733 16.6493V11.9813C16.3733 11.8576 16.273 11.7573 16.1493 11.7573H11.4813ZM9.63062 11.9813C9.63062 10.9592 10.4592 10.1306 11.4813 10.1306H16.1493C17.1714 10.1306 18 10.9592 18 11.9813V16.6493C18 17.6714 17.1714 18.5 16.1493 18.5H11.4813C10.4592 18.5 9.63062 17.6714 9.63062 16.6493V11.9813Z",
    fill: "#2858FD",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85067 8.12669C7.79127 8.12669 7.7343 8.15029 7.69229 8.19229C7.65029 8.2343 7.62669 8.29127 7.62669 8.35067V13.0187C7.62669 13.0781 7.65028 13.135 7.69229 13.1771C7.7343 13.2191 7.79127 13.2427 7.85067 13.2427H8.36934C8.81854 13.2427 9.18268 13.6068 9.18268 14.056C9.18268 14.5052 8.81854 14.8693 8.36934 14.8693H7.85067C7.35985 14.8693 6.88912 14.6744 6.54205 14.3273C6.19498 13.9802 6 13.5095 6 13.0187V8.35067C6 7.85985 6.19498 7.38912 6.54205 7.04205C6.88912 6.69498 7.35985 6.5 7.85067 6.5H12.5187C13.0095 6.5 13.4802 6.69498 13.8273 7.04205C14.1744 7.38912 14.3693 7.85985 14.3693 8.35067V8.86934C14.3693 9.31854 14.0052 9.68268 13.556 9.68268C13.1068 9.68268 12.7427 9.31854 12.7427 8.86934V8.35067C12.7427 8.29127 12.7191 8.2343 12.6771 8.19229C12.635 8.15028 12.5781 8.12669 12.5187 8.12669H7.85067Z",
    fill: "#2858FD",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySquareWhite);
export default __webpack_public_path__ + "static/media/copy-square-white.7da139c0.svg";
export { ForwardRef as ReactComponent };